import React, { useState, Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import numeral from 'numeral';
import isMobile from 'ismobilejs';
import { saveAs } from 'file-saver';

import styled from '@emotion/styled';

import MobileMainBlock from './MobileMainBlock';
import DesktopMainBlock from './DesktopMainBlock';

import { showModal } from '../../../../actions/modal';
import {
  fetchTags,
  fetchEmailRepeat,
  fetchPostOrderSync,
  fetchPostWBBarcodes,
  fetchExportOrderExcel,
  fetchUploadFbmDocsFF,
  fetchOrderInvoice,
  fetchPostDriverPermit,
} from '../../../../actions/orders';
import { fetchImportParsedProducts, fetchItemsTemplate } from '../../../../actions/imports';

import {
  getCurrencySymbol,
  getProductEncodedUrl,
  getYandexStoreImageMin,
  parseError,
  saveOctetStreamAsFile,
} from '../../../../helpers';

import { IMAGE_MAX_SIZE, MOCK_DELIVERY_ITEM } from '../../../../config';
import { useDropzone } from 'react-dropzone';
import Adaptive from '../../../common/Adaptive';
import Lock from '../../../common/Lock';
import { fetchExpirationDaysCalculateBatch } from '../../../../actions/auth';

const checkOnlyOrderedStatus = (state) => {
  return !Object.keys(state).some((key) => key !== 'amountORDERED' && state[key] !== 0);
};

const checkOnlyReservedStatus = (state) => {
  return !Object.keys(state).some(
    (key) => key !== 'amountORDERED' && key !== 'amountRESERVED' && state[key] !== 0,
  );
};

const checkOnlyPackedStatus = (state) => {
  return !Object.keys(state).some(
    (key) =>
      key !== 'amountORDERED' &&
      key !== 'amountRESERVED' &&
      key !== 'amountPACKED' &&
      state[key] !== 0,
  );
};

const checkOnlyShippedStatus = (state) => {
  return !Object.keys(state).some(
    (key) =>
      key !== 'amountORDERED' &&
      key !== 'amountRESERVED' &&
      key !== 'amountPACKED' &&
      key !== 'amountSHIPPED' &&
      state[key] !== 0,
  );
};

const getItemStatus = (item, isAnyDelivered) => {
  function getData() {
    const state = item.itemAmountState;
    if (!state) return { data: item };
    const {
      amountDELIVERED,
      amountORDERED,
      amountPACKED,
      amountRESERVED,
      amountRETURNED,
      amountSHIPPED,
      amountRETURNED_DEFECTIVE,
      amountRETURNED_TO_CLIENT,
      amountRETURNED_AS_CLAIMS,
      amountLOST,
    } = state;

    if (
      amountDELIVERED > amountORDERED ||
      amountPACKED > amountORDERED ||
      amountSHIPPED > amountORDERED ||
      amountRETURNED > amountORDERED ||
      amountRESERVED > amountORDERED ||
      amountRETURNED_TO_CLIENT > amountORDERED ||
      amountRETURNED_AS_CLAIMS > amountORDERED ||
      amountRETURNED_DEFECTIVE > amountORDERED ||
      amountLOST > amountORDERED
    ) {
      return { title: 'ошибка', style: 'red', data: item };
    }

    if (isAnyDelivered) {
      if (
        amountDELIVERED === amountORDERED &&
        !amountRETURNED_TO_CLIENT &&
        !amountRETURNED_AS_CLAIMS &&
        !amountRETURNED_DEFECTIVE &&
        !amountRETURNED
      ) {
        return { title: 'доставлено', style: 'green', data: item };
      }

      if (
        amountDELIVERED < amountORDERED ||
        (amountDELIVERED === amountORDERED && amountRETURNED_AS_CLAIMS)
      ) {
        const cancelCount =
          amountORDERED -
          amountDELIVERED -
          amountRETURNED_AS_CLAIMS -
          amountRETURNED_DEFECTIVE -
          amountLOST;

        const resultArr = [
          {
            title: 'доставлено',
            style: 'green',
            sum: amountDELIVERED * item.price,
            text: `Продано: ${amountDELIVERED} шт`,
            data: item,
          },
        ];

        if (cancelCount > 0) {
          resultArr.push({
            title: 'отказ',
            style: 'red',
            sum: cancelCount * item.price,
            text: `Отказ: ${cancelCount} шт`,
            minusSum: true,
            data: item,
          });
        }

        if (amountRETURNED - amountRETURNED_AS_CLAIMS > 0) {
          resultArr.push({
            title: 'возвращено',
            style: 'gray',
            sum: amountRETURNED * item.price,
            text: `Возврат: ${amountRETURNED - amountRETURNED_AS_CLAIMS} шт`,
            data: item,
          });
        }
        if (amountRETURNED_TO_CLIENT) {
          resultArr.push({
            title: 'возвращён клиенту напрямую',
            style: 'gray',
            sum: amountRETURNED_TO_CLIENT * item.price,
            text: `Возврат: ${amountRETURNED_TO_CLIENT} шт`,
            data: item,
          });
        }
        if (amountLOST) {
          resultArr.push({
            title: 'утерян',
            style: 'gray',
            sum: amountLOST * item.price,
            text: `Утеряно: ${amountLOST} шт`,
            minusSum: true,
            data: item,
          });
        }
        if (amountRETURNED_DEFECTIVE) {
          resultArr.push({
            title: 'Возвращено на брак',
            style: 'gray',
            sum: amountRETURNED_DEFECTIVE * item.price,
            text: `Возврат: ${amountRETURNED_DEFECTIVE} шт`,
            minusSum: true,
            data: item,
          });
        }
        if (amountRETURNED_AS_CLAIMS) {
          resultArr.push({
            title: 'возвращён по рекламации',
            style: 'gray',
            sum: amountRETURNED_AS_CLAIMS * item.price,
            text: `Рекламация: ${amountRETURNED_AS_CLAIMS} шт`,
            data: item,
          });
        }
        return resultArr;
      }
    }

    if (amountORDERED > 0 && checkOnlyOrderedStatus(state)) {
      return { title: 'нет резерва', style: 'orange', data: item };
    }

    if (amountRESERVED > 0 && checkOnlyReservedStatus(state)) {
      if (amountRESERVED === amountORDERED) {
        return { title: 'в резерве', style: 'green', data: item };
      } else {
        return [
          { title: 'в резерве', style: 'green', text: `Резерв: ${amountRESERVED} шт`, data: item },
          {
            title: 'нет резерва',
            style: 'orange',
            text: `Без резерва: ${amountORDERED - amountRESERVED} шт`,
            data: item,
          },
        ];
      }
    }

    if (amountPACKED > 0 && checkOnlyPackedStatus(state)) {
      if (amountPACKED === amountORDERED) {
        return { title: 'упаковано', style: 'green', data: item };
      } else {
        return [
          { title: 'упаковано', style: 'green', text: `Упаковано: ${amountPACKED} шт`, data: item },
          {
            title: 'не упаковано',
            style: 'orange',
            text: `Не упаковано: ${amountORDERED - amountPACKED} шт`,
            data: item,
          },
        ];
      }
    }

    if (amountSHIPPED > 0 && checkOnlyShippedStatus(state)) {
      if (amountSHIPPED === amountORDERED) {
        return { title: 'отгружено', style: 'green', data: item };
      } else {
        return [
          {
            title: 'отгружено',
            style: 'green',
            text: `Отгружено: ${amountSHIPPED} шт`,
            data: item,
          },
          {
            title: 'не отгружено',
            style: 'orange',
            text: `Не отгружено: ${amountORDERED - amountSHIPPED} шт`,
            data: item,
          },
        ];
      }
    }

    if (
      amountDELIVERED < amountORDERED &&
      ((amountORDERED !== amountRETURNED &&
        amountORDERED !== amountRETURNED_DEFECTIVE &&
        amountORDERED !== amountLOST) ||
        amountRETURNED_AS_CLAIMS)
    ) {
      const resultArr = [
        {
          title: 'доставлено',
          style: 'green',
          sum: amountDELIVERED * item.price,
          text: `Продано: ${amountDELIVERED} шт`,
          data: item,
        },
      ];

      if (amountRETURNED - amountRETURNED_AS_CLAIMS > 0) {
        resultArr.push({
          title: 'возвращено',
          style: 'gray',
          sum: amountRETURNED * item.price,
          text: `Возврат: ${amountRETURNED - amountRETURNED_AS_CLAIMS} шт`,
          data: item,
        });
      }
      if (amountRETURNED_TO_CLIENT) {
        resultArr.push({
          title: 'возвращён клиенту напрямую',
          style: 'gray',
          sum: amountRETURNED_TO_CLIENT * item.price,
          text: `Возврат: ${amountRETURNED_TO_CLIENT} шт`,
          data: item,
          minusSum: true,
        });
      }
      if (amountLOST) {
        resultArr.push({
          title: 'утерян',
          style: 'gray',
          sum: amountLOST * item.price,
          text: `Утеряно: ${amountLOST} шт`,
          data: item,
          minusSum: true,
        });
      }
      if (amountRETURNED_DEFECTIVE) {
        resultArr.push({
          title: 'возвращено на брак',
          style: 'gray',
          sum: amountRETURNED_DEFECTIVE * item.price,
          text: `Возврат: ${amountRETURNED_DEFECTIVE} шт`,
          data: item,
          minusSum: amountRETURNED_AS_CLAIMS ? false : true,
        });
      }
      if (amountRETURNED_AS_CLAIMS) {
        resultArr.push({
          title: 'возвращён по рекламации',
          style: 'gray',
          sum: amountRETURNED_AS_CLAIMS * item.price,
          text: `Рекламация: ${amountRETURNED_AS_CLAIMS} шт`,
          data: item,
        });
      }
      return resultArr;
    }

    if (amountRETURNED_DEFECTIVE) {
      return {
        title: 'возвращён на брак',
        style: 'gray',
        data: item,
        minusSum: true,
      };
    }

    if (amountLOST) {
      return {
        title: 'утерян',
        style: 'gray',
        minusSum: true,
        data: item,
      };
    }

    if (amountRETURNED) {
      return {
        title: 'возвращён',
        style: 'gray',
        sum: amountRETURNED * item.price,
        text: `Возврат: ${amountRETURNED} шт`,
        minusSum: true,
        data: item,
      };
    }

    if (amountRETURNED_TO_CLIENT) {
      return {
        title: 'возвращён клиенту напрямую',
        style: 'gray',
        data: item,
        minusSum: true,
      };
    }

    return { data: item };
  }

  return getData();
};

const getItemsStatuses = (data, currentOrder) => {
  const filteredData = data.filter((item) => item.skuType !== 'SERVICE');
  const isAnyDelivered = filteredData.some((item) => item.itemAmountState.amountDELIVERED > 0);

  if (
    isAnyDelivered &&
    ![
      'ORDER_INFO_DELIVERED',
      'ORDER_INFO_PARTIALLY_DELIVERED_NOT_RETURNED',
      'ORDER_INFO_PARTIALLY_DELIVERED_RETURNED',
      'ORDER_INFO_DONE',
      'ORDER_INFO_RETURNED_TO_CLIENT',
    ].includes(currentOrder.status)
  ) {
    return filteredData.map((data) => ({ title: 'ошибка', style: 'red', data }));
  }

  if (currentOrder.status === 'ORDER_INFO_CANCELED') {
    return filteredData.map((data) => ({ data }));
  }

  let resultArr = [];
  filteredData.forEach((item) => {
    const currentItemStatus = getItemStatus(item, isAnyDelivered);
    resultArr.push(currentItemStatus);
  });

  return resultArr;
};

const getItemStatusLabel = (variantId, statuses = [], num, t) => {
  //t - func, change locale i18n

  const statusData = num
    ? statuses.find(
        (s) =>
          s &&
          (!Array.isArray(s)
            ? s.data.variantId === variantId && s.data.num === num
            : s[0].data.variantId === variantId && s[0].data.num === num),
      )
    : statuses.find(
        (s) =>
          s &&
          (!Array.isArray(s) ? s.data.variantId === variantId : s[0].data.variantId === variantId),
      );

  if (!Array.isArray(statusData) && statusData) {
    return (
      <div className={`item-status item-status-${statusData.style}`}>{t(statusData.title)}</div>
    );
  } else {
    return (
      <div className="multiple-item-status">
        {statusData.map((s, i) => {
          return (
            <div key={`status-data-${i}`} className={`item-status item-status-${s.style}`}>
              {t(s.title)}
              {s.price ? (
                <Fragment>
                  <br />
                  {`${numeral(s.sum).format('0.[00]')} р.`}
                </Fragment>
              ) : null}
              <span>{t(s.text)}</span>
            </div>
          );
        })}
      </div>
    );
  }
};

const getNdsValue = (name) => {
  switch (name) {
    case 'NO_VAT':
      return null;
    case 'VAT_0':
      return 0;
    case 'VAT_5':
      return 5;
    case 'VAT_7':
      return 7;
    case 'VAT_10':
      return 10;
    case 'VAT_18':
      return 18;
    case 'VAT_20':
      return 20;
    default:
      return null;
  }
};

const getTotalNds = (currentOrder, isFact) => {
  const { items, summaryItemAmountState } = currentOrder;

  if (isFact && summaryItemAmountState?.amountRETURNED === summaryItemAmountState?.amountORDERED) {
    return 0;
  }

  if (isFact) {
    return (
      items &&
      items.reduce((a, c) => {
        const ndsValue = getNdsValue(c.vatRate);
        if (ndsValue !== null) {
          a +=
            ((c.price * c.itemAmountState?.amountDELIVERED) / (1 + ndsValue / 100) -
              c.price * c.itemAmountState?.amountDELIVERED) *
            -1;
        }
        return a;
      }, 0)
    );
  }

  return (
    items &&
    items.reduce((a, c) => {
      const ndsValue = getNdsValue(c.vatRate);
      if (ndsValue !== null) {
        a += ((c.price * c.quantity) / (1 + ndsValue / 100) - c.price * c.quantity) * -1;
      }
      return a;
    }, 0)
  );
};

const getFactSum = (currentOrder, itemsStatuses, sum) => {
  if (
    currentOrder.summaryItemAmountState?.amountRETURNED -
      currentOrder.summaryItemAmountState?.amountRETURNED_AS_CLAIMS ===
    currentOrder.summaryItemAmountState?.amountORDERED
  ) {
    return 0;
  }

  return itemsStatuses.reduce((a, c) => {
    if (Array.isArray(c)) {
      c.forEach((b) => {
        if (b.minusSum) {
          a -= b.sum;
        }
      });
    } else {
      if (c.minusSum) {
        a -= c.sum;
      }
    }
    return a;
  }, sum);
};

const getShowUploadFbmDocsButton = (status, requirements, packings, pallets, fbm) => {
  if (status !== 'ORDER_INFO_PACKED_DOCUMENTS_REQUIRED') return false;

  if (
    requirements?.packing_sticker_type === 'PDF' &&
    packings?.filter((p) => !p?.files?.length).length
  ) {
    if (fbm === 'OZON' && packings?.length > 10) {
      return true;
    } else if (fbm === 'FBO_B2B') {
      return true;
    } else {
      return false;
    }
  }

  if (
    requirements?.packing_sticker_type === 'TEXT' &&
    packings?.filter((p) => !p?.fbmStickerBarcode).length
  ) {
    if (fbm === 'OZON' && packings?.length > 10) {
      return true;
    } else if (fbm === 'FBO_B2B') {
      return true;
    } else {
      return false;
    }
  }

  if (
    requirements?.pallet_sticker_type === 'PDF' &&
    pallets?.filter((p) => !p?.files?.length).length
  ) {
    return false;
  }

  return true;
};

const MainBlock = (props) => {
  const {
    actualizeOrder,
    isNew,
    haveProducts,
    currentOrder,
    loadingOrder,
    currentWarehouse,
    sum,
    isManualWarehouse,
    loadingSticker,
    worksheetData,
    handleEditOrderItems,
    handleConfirmation,
    handleRefreshReserve,
    handleCancel,
    handleUpdateDeliveryResult,
    handlePacking,
    handleSendPackingControl,
    handleDownloadSticker,
    handleCopyOrder,
    handleAddTag,
    handleEditOrder,
    handleEditDiscounts,
    handlePhoneCallBack,
    unsavedMaterials,
    setUnsavedMaterials,
    updateBatch,
    switchBatchUpdate,
  } = props;

  const dispatch = useDispatch();
  const [showActions, setShowActions] = useState(false);

  const [uploadToFulfilmentLoading, setUploadToFulfilmentLoading] = useState(false);
  const [filesUploadLoading, setFilesUploadLoading] = useState(false);
  const [loadingUploadFbmDocsButton, setLoadingUploadFbmDocsButton] = useState(false);
  const [loadingDriverPermit, setLoadingDriverPermit] = useState(false);
  const [currentPackingMaterials, setCurrentPackingMaterials] = useState([]);
  const [isDraft, setIsDraft] = useState(false);

  const history = useHistory();
  const { checkoutSettings } = useSelector((state) => state.settings);
  const { tags } = useSelector((state) => state.orders);
  const deliveryInfo = useSelector((state) => state.orders.deliveryInfo);

  const authData = useSelector((state) => state.auth); //If you need TOKEN
  const worksheetShipmentCode = useSelector((state) => state.orders?.worksheetShipmentCode);

  const hasDiscount =
    currentOrder.promocodeAppliedDiscount ||
    currentOrder.manualAppliedDiscount ||
    currentOrder.paymentMethodAppliedDiscount;

  const getPriceBeforeDiscount = (sum) => {
    let newSum = sum;
    if (currentOrder.promocodeAppliedDiscount) {
      newSum = newSum + currentOrder.promocodeAppliedDiscount;
    }
    if (currentOrder.manualAppliedDiscount) {
      newSum = newSum + currentOrder.manualAppliedDiscount;
    }
    if (currentOrder.paymentMethodAppliedDiscount) {
      newSum = newSum + currentOrder.paymentMethodAppliedDiscount;
    }

    return newSum;
  };

  useEffect(() => {
    if (!tags) dispatch(fetchTags());
  }, [dispatch, tags]);

  const handleUploadToFulfillment = async () => {
    setUploadToFulfilmentLoading(true);
    await dispatch(fetchPostOrderSync(currentOrder.id))
      .then(async () => {
        await actualizeOrder(currentOrder.id);
        toast.info('Заказ успешно выгружен на фуллфилмент');
      })
      .catch((err) => {
        toast.error(parseError(err));
      });
    setUploadToFulfilmentLoading(false);
  };

  const handleSetDelivery = () => {};

  const handleAcceptReturn = () => {};

  const getFbm = () => {
    const deliveryCode = deliveryInfo?.find((info) => info.code === currentOrder?.delivery?.code);
    return deliveryCode?.fbmType;
  };

  const handleRemoveItem = (item) => {
    if (isDraft) {
      const newItems = currentPackingMaterials.filter(
        (innerItem) => innerItem.barcode !== item.barcode,
      );
      setCurrentPackingMaterials(newItems);
      setUnsavedMaterials(true);
    } else {
      dispatch(
        showModal('ConfirmRemoveOrderItem', {
          handleConfirm: () => removeItem(item),
          item,
          currencySymbol,
          getNdsValue,
          getItemStatusLabel,
          itemsStatuses,
        }),
      );
    }
  };

  const removeItem = (item) => {
    const newItems = currentOrder.items.slice();
    const currentIndex = newItems.findIndex(
      (i) => i.productId === item.productId && i.variantId === item.variantId,
    );
    newItems.splice(currentIndex, 1);
    //handleEditOrderItems(newItems);
    handleEditOrderItems(newItems.map((item, i) => ({ ...item, num: i + 1 })));
  };

  const handleOpenItemModal = (item, itemIndex) => {
    dispatch(
      showModal('EditOrderItem', {
        currentItem: item,
        submitCallback: (values) => {
          let newItems = [];
          if (!isNew) {
            newItems = isDraft ? currentPackingMaterials.slice() : sortedData.slice();

            if (values.quantity) {
              newItems = newItems.map((c, i) => {
                if (
                  c.productId === item.productId &&
                  c.variantId === item.variantId &&
                  itemIndex === i
                ) {
                  return {
                    ...c,
                    price: values.price,
                    quantity: values.quantity,
                    vatRate: values.vatRate,
                  };
                }
                return c;
              });
            } else {
              const currentItemIndex = newItems.findIndex(
                (c, i) =>
                  c.productId === item.productId &&
                  c.variantId === item.variantId &&
                  itemIndex === i,
              );
              if (currentItemIndex !== -1) {
                newItems.splice(currentItemIndex, 1);
              }
            }
          } else {
            newItems = [
              {
                ...MOCK_DELIVERY_ITEM,
                price: values.price,
                vatRate: values.vatRate,
              },
            ];
          }

          if (isDraft) {
            setCurrentPackingMaterials(newItems);
            setUnsavedMaterials(true);
          } else {
            handleEditOrderItems(newItems);
          }
        },
      }),
    );
  };

  const handleAddItem = () => {
    if (!currentWarehouse) {
      toast.error('Перед добавлением товара, необходимо указать склад отгрузки');
      return false;
    }

    const deliveryItem =
      !isNew && currentOrder.items && currentOrder.items.length
        ? currentOrder.items.find((i) => i.variantId === 'delivery')
        : MOCK_DELIVERY_ITEM;

    const requestExpirationDaysCalculateBatch = async (requestBody) => {
      const tokens = authData.tokenData;
      const res = await dispatch(fetchExpirationDaysCalculateBatch(requestBody, tokens)).catch(
        (error) => {
          toast.error(error.data.errors[0].message || 'Ошибка при расчете ОСГ!');
          return;
        },
      );

      return res;
    };

    //TODO: При добавлении товара в заказ надо дергать батч - но это сложно чёт, надо его считать и для текущих товаров, и для новых
    //TODO: Вынес в редакс стор и получаю из него данные про расчитанный батч
    //TODO: Есть смысл перерисовать именно сам мэйн таблицу после успешного добавления товаров и апдейта всего заказа
    //TODO: Т.е. тригернуть основной батч на мэйне, а не дерагать его из модалки

    // const defineAddedProductsThatAreNotInTheOrder = async (allItems) => {
    //   const isNewOrder = !currentOrder?.id;
    //   if (isNewOrder) return allItems;

    //   const justAddedNewItems = [];
    //   let matched = false;
    //   for (let i = 0; i < allItems.length; i++) {
    //     for (let j = 0; j < currentOrder.items.length; j++) {
    //       if (allItems[i].variantId === currentOrder.items[j].variantId) {
    //         matched = true;
    //       } else {
    //         //Не найдено совпадений && Проверили currentOrder до конца
    //         if (!matched && j === currentOrder.items.length - 1) {
    //           justAddedNewItems.push(allItems[i]); //Добавить несовпавшие объекты в массив
    //         }
    //       }
    //     }
    //     matched = false;
    //   }

    //   return justAddedNewItems;
    // };

    const createBodyForBatchRequest = (selectedFbmType) => {
      // const ids = getItemsIDs(); //! Ошибка - удалить и перенести вызов на мэйн

      const body = { items: [] };

      // let currentDelivery = null;
      // if (currentOrder.delivery) {
      //   currentDelivery = deliveryInfo.filter(
      //     (delivery) => delivery.deliveryCode === currentOrder.delivery.deliveryCode,
      //   );
      // }

      // const fbmTypeToRequest = selectedFbmType || currentDelivery[0]?.fbmType || null;

      // for (let i = 0; i < ids.length; i++) {
      //   body.items.push({
      //     id: ids[i],
      //     fbmType: fbmTypeToRequest,
      //     percent: null,
      //   });

      //   if (worksheetShipmentCode && fbmTypeToRequest === 'RETAIL_NETWORK') body.items[i].fbmSubTypeCode = worksheetShipmentCode;
      // }

      return body;
    };

    const handleExpirationDateCalculation = async (allItems) => {
      // if (allItems.length === 0) return;

      // const newItemsToCalculateExpirationDays = { items: [] };
      // const justAddedNewItems = await defineAddedProductsThatAreNotInTheOrder(allItems);
      // justAddedNewItems.forEach(async (item) => {
      //   newItemsToCalculateExpirationDays.items.push({
      //     id: item.variantId,
      //     fbmType: getFbm() || null,
      //   });
      // });

      const body = createBodyForBatchRequest();
      const res = await requestExpirationDaysCalculateBatch(body);
      return res;
    };

    dispatch(
      showModal('OrderAddingProducts', {
        currentProducts: currentOrder.items,
        currentWarehouse,
        needVariants: true,
        onProductsAdding: async (result) => {
          const resultCache = result.slice();
          const newItems = [];

          if (currentOrder.items) {
            currentOrder.items.forEach((p) => {
              if (p.variantId !== 'delivery') {
                const findCurrentProductIndexInResultCache = resultCache.findIndex(
                  (i) => i.id === p.productId && i.variantId === p.variantId,
                );

                if (findCurrentProductIndexInResultCache === -1) {
                  newItems.push({ ...p, num: newItems.length + 1 });
                } else {
                  const findCurrentProduct = {
                    ...resultCache[findCurrentProductIndexInResultCache],
                  };
                  const currentVariant = findCurrentProduct.variants.find(
                    (v) => v.id === p.variantId,
                  );
                  if (findCurrentProduct.quantity) {
                    newItems.push({
                      num: newItems.length + 1,
                      variantId: findCurrentProduct.variantId,
                      productId: findCurrentProduct.id,
                      productExtId: findCurrentProduct.extId,
                      name: `${findCurrentProduct.shortName} ${
                        currentVariant.optionsUsed
                          ? currentVariant.optionsUsed?.map((o) => o.stringValue).join(' ')
                          : ''
                      }`,
                      quantity: findCurrentProduct.quantity,
                      price: p.price || currentVariant.price || 0,
                      img: currentVariant.defaultImage,
                      vatRate: p.vatRate || 'NO_VAT',
                      dimensions: currentVariant.dimensions,
                      weight: currentVariant.weight,
                      bundleOptionalVariants: findCurrentProduct.bundleOptionalVariants,
                      packingMaterials: findCurrentProduct.packingMaterials || null,
                    });
                  }
                  resultCache.splice(findCurrentProductIndexInResultCache, 1);
                }
              }
            });
          }

          if (resultCache.length) {
            resultCache.forEach((p) => {
              const currentVariant = p.variants.find((v) => v.id === p.variantId);
              if (p.quantity) {
                newItems.push({
                  num: newItems.length + 1,
                  variantId: p.variantId,
                  productId: p.id,
                  productExtId: p.extId,
                  name: `${p.shortName} ${
                    currentVariant.optionsUsed
                      ? currentVariant.optionsUsed?.map((o) => o.stringValue).join(' ')
                      : ''
                  }`,
                  quantity: p.quantity,
                  price: currentVariant.price || 0,
                  img: currentVariant.defaultImage,
                  vatRate: currentVariant.vat || 'NO_VAT',
                  dimensions: currentVariant.dimensions,
                  weight: currentVariant.weight,
                  bundleOptionalVariants: p.bundleOptionalVariants,
                });
              }
            });
          }

          // const expirationDataForNewItems = await handleExpirationDateCalculation(newItems);

          newItems.map(function (item) {
            var matchingProduct = sortedData.filter((data) => item.variantId === data.variantId);
            if (matchingProduct.length > 0 && matchingProduct[0].expirationDays) {
              item.expirationDays = matchingProduct[0].expirationDays;
            }
            return item;
          });

          // newItems.map(function (item) {
          //   var matchingProduct = expirationDataForNewItems.result.filter(
          //     (data) => item.variantId === data.id,
          //   );
          //   if (matchingProduct.length > 0 && matchingProduct[0].value) {
          //     item.expirationDays = matchingProduct[0].value;
          //   }
          //   return item;
          // });

          newItems.push({ ...deliveryItem, num: newItems.length + 1 });
          handleEditOrderItems(newItems);
        },
      }),
    );
  };

  const handleImportFromExcel = () => {
    dispatch(
      showModal('ImportProductsFromExcel', {
        handleImport: async (file, searchColumnType) => {
          const res = await dispatch(fetchImportParsedProducts(file));

          if (res.items && res.items.length) {
            const newItems = [...currentOrder.items];

            const findDeliveryItem = newItems.find((i) => i.variantId === 'delivery');
            if (findDeliveryItem) {
              findDeliveryItem.num = newItems.length + res.items.length + 1;
            } else {
              newItems.push({ ...MOCK_DELIVERY_ITEM, num: newItems.length + res.items.length + 1 });
            }

            res.items.forEach((item) => {
              newItems.push({ ...item, num: newItems.length });
            });

            await handleEditOrderItems(newItems, { searchColumnType });
          }

          return res;
        },

        handleLoadImportTemplate: () => {
          dispatch(fetchItemsTemplate()).then((res) => {
            saveOctetStreamAsFile({
              content: res.data,
              fileName: 'productsTemplate.xls',
            });
          });
        },
      }),
    );
  };

  const handleEditTag = (evt, order) => {
    evt.stopPropagation();
    dispatch(
      showModal('ChooseTags', {
        orderId: order.id,
        orderTags: order.tags,
        update: () => actualizeOrder(currentOrder.id),
      }),
    );
  };

  const handleSendEmail = () => {
    const haveEmail =
      currentOrder.delivery &&
      currentOrder.delivery.receiver &&
      currentOrder.delivery.receiver.email;
    if (haveEmail) {
      dispatch(
        fetchEmailRepeat({
          id: currentOrder.id,
          c: currentOrder.c,
        }),
      )
        .then(() => {
          toast.info('Оповещение успешно отправлено');
        })
        .catch((err) => {
          toast.error(parseError(err));
        });
    } else {
      toast.error('Для отправки оповещения необходимо указать адрес электронной почты в заказе');
    }
  };

  const handleOpenEditSale = () => {
    dispatch(
      showModal('EditOrderSale', {
        currentOrder,
        submitCallback: handleEditDiscounts,
      }),
    );
  };

  const handleExportExcel = async () => {
    try {
      const result = await dispatch(fetchExportOrderExcel(currentOrder.id));
      if (result.success) {
        saveAs(result.fileUrl, result.fileID);
      } else {
        toast.error(`Ошибка экспорта в Excel`);
      }
    } catch {
      toast.error(`Ошибка экспорта в Excel`);
    }
  };

  const handleInvoice = async () => {
    try {
      const result = await dispatch(fetchOrderInvoice(currentOrder.id));
      if (result.success) {
        saveAs(result.fileUrl, result.fileID);
      } else {
        toast.error(`Ошибка получения инвойса`);
      }
    } catch {
      toast.error(`Ошибка получения инвойса`);
    }
  };

  const handleOpenPhoneCallBack = () => {
    dispatch(
      showModal('PhoneCallBack', {
        currentOrder,
        submitCallback: handlePhoneCallBack,
      }),
    );
  };

  const handleUploadFbmDocsButton = async () => {
    setLoadingUploadFbmDocsButton(true);

    await dispatch(fetchUploadFbmDocsFF({ id: currentOrder.id }))
      .then(async () => {
        await actualizeOrder(currentOrder.id);
        toast.info('Документы успешно загружены');
      })
      .catch((err) => {
        toast.error(parseError(err));
      });

    setLoadingUploadFbmDocsButton(false);
  };

  const handleUploadDriverPermit = async () => {
    setLoadingDriverPermit(true);
    await dispatch(fetchPostDriverPermit(currentOrder.id))
      .then(() => {
        toast.info('Операция успешно выполнена');
      })
      .catch((err) => {
        toast.error(parseError(err));
      });

    setLoadingDriverPermit(false);
  };

  const onDropAccepted = async (acceptedFiles) => {
    setFilesUploadLoading(true);
    try {
      await dispatch(fetchPostWBBarcodes(currentOrder.id, acceptedFiles[0]));
      toast.info(`Штрих-коды загружены успешно`);
    } catch (e) {
      console.error(e);
      toast.error(`Ошибка загрузки штрих-кодов`);
    }
    setFilesUploadLoading(false);
    actualizeOrder(currentOrder.id);
  };

  const onDropRejected = () => {
    toast.error('Ошибка загрузки файла. Максимальный размер файла 10 мб');
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDropAccepted,
    onDropRejected,
    multiple: false,
    accept: ['.xls', '.xlsx'],
    maxSize: IMAGE_MAX_SIZE,
  });

  const tableDataForRendering =
    currentOrder.items && currentOrder.items.length ? currentOrder.items : [MOCK_DELIVERY_ITEM];

  const sortedData = tableDataForRendering.sort((a, b) => {
    if (a.num > b.num) return 1;
    if (a.num < b.num) return -1;
    return 0;
  });
  const allQuantity = sortedData.reduce((a, c) => {
    if (c.variantId !== 'delivery' && c.quantity) {
      if (!c.multiplicity) {
        a += c.quantity;
      } else if (c.multiplicity) {
        a = a + c.quantity * c.multiplicity;
      }
    }
    return a;
  }, 0);

  const itemsStatuses = getItemsStatuses(sortedData, currentOrder);

  const haveProductsWithoutReserve =
    currentOrder.items && [].concat(...itemsStatuses).some((s) => s.title === 'нет резерва');

  const factSum = getFactSum(currentOrder, itemsStatuses, sum);

  const currencySymbol = currentOrder.currency
    ? getCurrencySymbol(currentOrder.currency)
    : getCurrencySymbol(checkoutSettings.currency);

  const permissions =
    currentOrder.permissionList &&
    currentOrder.permissionList.actionPermissions &&
    currentOrder.permissionList.actionPermissions.reduce((a, c) => {
      a[c.type] = { ...c };
      return a;
    }, {});
  const refreshReservePermission = permissions && permissions['REFRESH_RESERVE'];

  const findItemsEditablePermission =
    currentOrder.permissionList &&
    currentOrder.permissionList.fieldPermissions &&
    currentOrder.permissionList.fieldPermissions.find((p) => p.type === 'ITEMS_EDITABLE');
  const itemsEditablePermission = findItemsEditablePermission
    ? findItemsEditablePermission
    : { value: true };

  const handleNewTicket = () => {
    dispatch(
      showModal('NewTicket', {
        subject: currentOrder.id || '',
        notReturnToList: true,
      }),
    );
  };

  const [showUploadFbmDocsButton, setShowUploadFbmDocsButton] = useState(false);

  useEffect(() => {
    const showUploadFbmDocsButton = getShowUploadFbmDocsButton(
      currentOrder?.status,
      worksheetData?.requirements,
      currentOrder?.packings,
      currentOrder?.pallets,
      getFbm(),
    );

    setShowUploadFbmDocsButton(showUploadFbmDocsButton);
  }, [currentOrder.status]);

  const handleChangeNeedReserve = (checked) => {
    handleEditOrder({
      ...currentOrder,
      needReserve: checked,
    });
  };

  const defaultReserveOrders = checkoutSettings?.defaultReserveOrders;

  const adaptiveProps = {
    loadingOrder,
    currentOrder,
    handleEditTag,
    isNew,
    permissions,
    refreshReservePermission,
    handleUpdateDeliveryResult,
    handleConfirmation,
    isManualWarehouse,
    loadingSticker,
    loadingUploadFbmDocsButton,
    handlePacking,
    handleSendPackingControl,
    handleDownloadSticker,
    showActions,
    showUploadFbmDocsButton,
    haveProductsWithoutReserve,
    setShowActions,
    handleUploadToFulfillment,
    uploadToFulfilmentLoading: isMobile().any ? undefined : uploadToFulfilmentLoading,
    handleSetDelivery,
    handleAcceptReturn,
    handleRefreshReserve,
    handleCancel,
    handleCopyOrder,
    handleImportFromExcel,
    sortedData,
    handleOpenItemModal,
    currencySymbol,
    getItemStatusLabel,
    getItemStatus,
    itemsStatuses,
    handleRemoveItem,
    handleAddItem,
    allQuantity,
    sum,
    factSum,
    getTotalNds,
    haveProducts,
    getNdsValue,
    history,
    itemsEditablePermission,
    handleAddTag: isMobile().any ? handleAddTag : undefined,
    handleSendEmail,
    handleEditOrder: isMobile().any ? undefined : handleEditOrder,
    dispatch: isMobile().any ? undefined : dispatch,
    getRootProps: isMobile().any ? undefined : getRootProps,
    getInputProps: isMobile().any ? undefined : getInputProps,
    filesUploadLoading: isMobile().any ? undefined : filesUploadLoading,
    currentWarehouse,
    handleNewTicket,
    handleOpenEditSale,
    handleOpenPhoneCallBack,
    handleExportExcel,
    handleUploadFbmDocsButton,
    defaultReserveOrders,
    handleChangeNeedReserve,
    handleInvoice,
    hasDiscount,
    getPriceBeforeDiscount,
    actualizeOrder,
    handleEditOrderItems,
    worksheetDataRequirements: worksheetData?.requirements,
    handleUploadDriverPermit,
    setLoadingDriverPermit,
    loadingDriverPermit,
    currentPackingMaterials,
    setCurrentPackingMaterials,
    isDraft,
    setIsDraft,
    unsavedMaterials,
    setUnsavedMaterials,
    updateBatch,
    switchBatchUpdate,
  };

  return (
    <Adaptive
      DekstopComponent={DesktopMainBlock}
      MobileComponent={MobileMainBlock}
      adaptiveProps={adaptiveProps}
    />
  );
};

export default MainBlock;
